// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/updated.php
export default {
	name: 'collection.updated',
	priority: 79,
	require: function(config, filter) {
		return filter.collection && (filter.collection.updated.from || filter.collection.updated.to)
	},
	run: function(config, filter, data, query) {
		if (filter.collection.updated.from) query.where('c.collection_date_updated', '>=', filter.collection.updated.from)
		if (filter.collection.updated.to) query.where('c.collection_date_updated', '<=', filter.collection.updated.to)
	}
}
